module.exports = __webpack_public_path__ + "img/debtPayingAbility4.c584212a.png";